import { render } from "./DesignArt.vue?vue&type=template&id=07851f16&scoped=true"
import script from "./DesignArt.vue?vue&type=script&lang=js"
export * from "./DesignArt.vue?vue&type=script&lang=js"

import "./DesignArt.vue?vue&type=style&index=0&id=07851f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07851f16"]])

export default __exports__